<template>
  <div>
    <hr />
    <b-tabs content-class="mt-3">
      <b-tab title="Cargos Justificados">
        <tabla-base detallerender="cargopersonal" :items="solicitudSeleccionada.tablacargos.items" :fields="solicitudSeleccionada.tablacargos.fields"></tabla-base>
      </b-tab>
      <b-tab title="Archivos adjuntos">
        <b-row v-if="solicitudSeleccionada.objeto" class="mb-2 text-left">
          <b-col cols="2">
            <b-button-toolbar aria-label="Barra de opciones">
              <b-button-group class="mx-1">
                <b-button
                 v-if="solicitudSeleccionada.objeto.EstadoSolicitudMedica === 1 || isInRoleAdmin"
                 variant="secondary"
                 @click.stop="agregarAdjunto(solicitudSeleccionada.objeto)">
                 Agregar adjunto
                </b-button>
              </b-button-group>
            </b-button-toolbar>
          </b-col>
          <b-col cols="10">
            <b-alert v-if="!solicitudSeleccionada.objeto.Adjunto && solicitudSeleccionada.objeto.ListaAdjunto.length === 0" variant="danger" show>
              No existe archivo adjunto.
            </b-alert>
            <b-btn v-if="solicitudSeleccionada.objeto.Adjunto" target="_blank" :href="(this.cdn_file_url + solicitudSeleccionada.objeto.Adjunto)">Descargar {{solicitudSeleccionada.objeto.Adjunto}} <b-icon icon="download"></b-icon></b-btn>
            <b-list-group v-if="solicitudSeleccionada.objeto.ListaAdjunto">
              <b-list-group-item target="_blank" v-for="adj in solicitudSeleccionada.objeto.ListaAdjunto" :key="adj"  :href="(cdn_file_url + adj)">Descargar {{adj}} <b-icon icon="download"></b-icon></b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Historial de Cambios" active>
        <tabla-base detallerender="historialsolicitud" :items="solicitudSeleccionada.tablahistorial.items.filter(c => !(c.EstadoSolicitudMedica === 'Recibido' && c.Observaciones !== null ) || isInRoleCoordinador )" :fields="solicitudSeleccionada.tablahistorial.fields"></tabla-base>
      </b-tab>
      <b-tab v-if="solicitudSeleccionada.objeto ? solicitudSeleccionada.objeto.LicenciaCargoPersonal : false" title="Licencia">
        <b-row v-if="solicitudSeleccionada.objeto" class="mb-2 text-left">
          <b-col v-if="solicitudSeleccionada.objeto.LicenciaCargoPersonal">
            <card-detalle-licencia :licencia="solicitudSeleccionada.objeto.LicenciaCargoPersonal"></card-detalle-licencia>
          </b-col>
        </b-row>
        <b-row class="mb-2 text-left">
          <b-col>
              <b-button variant="success" size="sm" @click="descargarConstancia(solicitudSeleccionada.objeto.LicenciaCargoPersonal.Id)">
                Descargar constancia
                <b-icon icon="file-earmark-medical"></b-icon>
              </b-button>
              <b-button variant="success" size="sm" @click="emitirConstancia(solicitudSeleccionada.objeto.LicenciaCargoPersonal.Id)">
                Emitir constancia
                <b-icon icon="file-earmark-medical"></b-icon>
              </b-button>
              <!-- <b-button v-if="(solicitudSeleccionada.objeto.TipoSolicitudMedica === 0 || solicitudSeleccionada.objeto.TipoSolicitudMedica === 1 || solicitudSeleccionada.objeto.TipoSolicitudMedica === 2 )" variant="success" size="sm" @click="emitirConstanciaAlta(solicitudSeleccionada.objeto.LicenciaCargoPersonal.Id)">
                Emitir Alta Médica
                <b-icon icon="file-earmark-medical"></b-icon>
              </b-button> -->
            </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import api from "@/api";
import { createHelpers } from 'vuex-map-fields';
import TablaBase from "../common/TablaBase.vue";
import CardDetalleLicencia from './CardDetalleLicencia.vue';
import axios from "axios";
import { mapGetters } from "vuex";

const { mapFields } = createHelpers({
  getterType: 'SolicitudModule/getSolicitudField',
  mutationType: 'SolicitudModule/updateSolicitudField',
});

export default {
  name: "DetalleSolicitud",
  props: {
  },
  watch: {
  },
  components: {
    TablaBase, CardDetalleLicencia
  },
  computed: {
    ...mapGetters(['isInRoleAdmin',"isInRoleEstablecimiento", "isInRoleCoordinador"]),
    ...mapFields({
      solicitudSeleccionada: 'selected'
    }),
  },
  data() {
    return {
      cdn_file_url: process.env.CDN_FILE_URL
    };
  },
  methods: {
    agregarAdjunto(item) {
      this.$router.push({ name: 'agregaradjunto', params: { solicitud: item } });
    },
    descargarConstancia(id) {
      this.disabled = true;

      axios({
        url: api.url + "/LicenciaCargoPersonal/GetConstancia/" + id,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        //link.setAttribute('download', 'constancia.pdf');
        link.setAttribute("download", "constancia.docx");
        document.body.appendChild(link);
        link.click();

        this.disabled = false;
      });
    },
    emitirConstancia(id) {
      axios({
        url: api.url + "/LicenciaCargoPersonal/GetConstanciaPdf/" + id,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        console.log('response', response);
        var blob = new Blob([response.data], {type: 'application/pdf'});
        var blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      });
    },
    emitirConstanciaAlta(id) {
      axios({
        url: api.url + "/LicenciaCargoPersonal/GetConstanciaAltaPdf/" + id,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        console.log('response', response);
        var blob = new Blob([response.data], {type: 'application/pdf'});
        var blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      });
    },
  },
  mounted(){
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/DetalleSolicitud.vue